import {combineReducers} from 'redux';
import OrderGroups from './ListOrderGroup/reducer';

export default combineReducers({
    orderGroups: OrderGroups,
});
